/* tslint:disable */
/* eslint-disable */
export enum WorkMontageplanLinkedProjectTypeEnum {
  Preceding = 'PRECEDING',
  Parallel = 'PARALLEL',
  Subsequent = 'SUBSEQUENT'
}
